var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('split-revenue-component',{attrs:{"type":_vm.type,"federation-ref":_vm.federationRef,"max-percentage":_vm.maxPercentage,"max-absolute":_vm.maxAbsolute,"articles":_vm.articles},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }